import { ApplicationQuestionAnswerFormatEnum } from './application-question-answer-format-enum.generated';

const x: { [index: string]: string } = {};
x[ApplicationQuestionAnswerFormatEnum.None] = 'None';
x[ApplicationQuestionAnswerFormatEnum.MultipleChoice] = 'Multiple Choice';
x[ApplicationQuestionAnswerFormatEnum.FreeResponse] = 'Free Response';
x[ApplicationQuestionAnswerFormatEnum.EmailAddress] = 'Email Address';
x[ApplicationQuestionAnswerFormatEnum.PhoneNumber] = 'Phone Number';
export const ApplicationQuestionAnswerFormatEnumDescriptions: { [indexer: string]: string } = x;
